<template>
  <div class="lg:grid lg:grid-cols-12 items-center">
    <div class="lg:col-span-7 xl:col-span-6" ref="header">
      <calculator-cta-header @swapComponent="swapComponent"/>
    </div>
    <div class="lg:col-span-5 xl:col-span-6" ref="svg">
      <calculator-cta-svg/>
    </div>
  </div>
</template>

<script>
import CalculatorCtaHeader from "@/components/calculator-steps/calculator-cta/CalculatorCtaHeader";
import CalculatorCtaSvg from "@/components/calculator-steps/calculator-cta/CalculatorCtaSvg";
import {gsap} from 'gsap'

export default {
  name: "CalculatorCta",
  components: {
    CalculatorCtaHeader,
    CalculatorCtaSvg
  },
  methods: {
    swapComponent(step) {
      const header = this.$refs['header']
      const svg = this.$refs['svg']
      const tl = gsap.timeline({onComplete: () => this.$emit('swapComponent', step)})
      tl.to(header, {y: 50, opacity: 0, ease: 'slow'})
      tl.to(svg, {y: -50, opacity: 0, ease: 'slow'}, 0)

    }
  }
};
</script>

<style>
</style>
